import * as React from "react";

import { SVG as SVGComponent, SVGProps } from "../../components/SVG/SVG";
import { withAction } from "../Actions/withActions";

class SVG extends React.PureComponent<SVGProps> {
  render() {
    return <SVGComponent {...this.props} />;
  }
}

export default withAction(SVG);
